import React, { useState, useRef, useEffect } from "react";
import { pb4y as api } from "../../../../services/apis";
import { producaov2 as api2 } from "../../../../services/apis";
import { Button, Form, Input } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/CKEditorFull";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const CriarPocket = (props) => {
  const [selectedFileHorizontal, setSelectedFileHorizontal] = useState("");
  const [selectedFileVertical, setSelectedFileVertical] = useState("");
  const [segmentos, setSegmentos] = useState([]);
  const checkboxes = useRef([]);
  const text = useRef("");
  const imagem = useRef({
    horizontal: "",
    vertical: "",
  });
  const [pocket, setPocket] = useState({
    linguagem: "BR",
    titulo: "",
    subtitulo: "",
    tituloGoogle: "",
    descricao: "",
    url: "",
    vendido: "0",
    avaliado: "0",
    recomendado: "0",
  });
  const optionBoolean = [
    { id: 0, text: "não" },
    { id: 1, text: "sim" },
  ];
  const optionsSelect = [
    { id: "BR", text: "BR" },
    { id: "EN", text: "EN" },
    { id: "ES", text: "ES" },
    { id: "DE", text: "DE" },
    { id: "RU", text: "RU" },
    { id: "ZH", text: "ZH" },
    { id: "FR", text: "FR" },
    { id: "IT", text: "IT" },
  ];
  useEffect(() => {
    loadAuth();
    loadSegments();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadSegments = async () => {
    api
      .get(`segments`)
      .then((res) => {
        setSegmentos(res.data);
      })
      .catch((err) => swal("Ops! ocorreu um erro nos segmentos", err, "error"));
  };

  const create = async () => {
    if (selectedFileHorizontal != "") {
      await uploadImageHorizontal();
    }
    if (selectedFileVertical != "") {
      await uploadImageVertical();
    }
    const payload = {
      titulo: pocket.titulo,
      subtitulo: pocket.subtitulo,
      conteudo: text.current,
      linguagem: pocket.linguagem,
      url: pocket.url,
      classe_book: JSON.stringify(checkboxes.current),
      imagem2: imagem.current.horizontal,
      imagem: imagem.current.vertical,
      mais_vendidos: pocket.vendido,
      melhor_avaliado: pocket.avaliado,
      recomendado: pocket.recomendado,
      titulo_google: pocket.tituloGoogle,
      meta_descricao: pocket.descricao,
      ativo: "1",
    };

    const pocketValidation = await yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      subtitulo: yup
        .string("Necessário que informe o subtitulo")
        .required("Necessário que informe o subtitulo"),
      conteudo: yup
        .string("Necessário que informe o texto")
        .required("Necessário que informe o texto"),
      meta_descricao: yup
        .string("Necessário que informe o meta descrição")
        .required("Necessário que informe o meta descrição"),
      url: yup
        .string("Necessário que informe a url")
        .required("Necessário que informe a url"),
    });

    try {
      await pocketValidation.validate(payload, { abortEarly: true });
      api
        .post(`pocketbooks/create`, payload)
        .then(async (res) => {
          let logs = {
            local: "PocketBook",
            texto: `criou o artigo de id=${res.data.id}`,
          };
          await api2.post("system_logs", { acao: JSON.stringify(logs) });
          swal(" Pocket salvo com sucesso", "", "success").then((res) =>
            props.history.push("/admin/blog/pocketbook4you")
          );
        })
        .catch((err) => {
          swal("Não foi possível salvar o pocket", err, "").then((res) =>
            props.history.push("/admin/blog/pocketbook4you")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };
  const uploadImageHorizontal = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFileHorizontal);
      inputData.append("path", `pocketbook4you/Artigos`);

      await api
        .post(`/upload`, inputData)
        .then((res) => (imagem.current["horizontal"] = res.data.url));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const uploadImageVertical = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFileVertical);
      inputData.append("path", `pocketbook4you/Artigos`);

      await api
        .post(`/upload`, inputData)
        .then((res) => (imagem.current["vertical"] = res.data.url));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const modifyCheckbox = (checked, ordem) => {
    if (checked == true) {
      if (checkboxes.current.indexOf(`${ordem}`) == -1) {
        checkboxes.current = [...checkboxes.current, `${ordem}`];
      }
    }
    if (checked == false) {
      if (checkboxes.current.indexOf(`${ordem}`) > -1) {
        const newArray = checkboxes.current;
        newArray.splice(newArray.indexOf(`${ordem}`), 1);
        checkboxes.current = newArray;
      }
    }
  };
  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>PocketBook4You</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Linguagem</Label>
                <select
                  onChange={(e) =>
                    setPocket({ ...pocket, linguagem: e.target.value })
                  }
                >
                  {optionsSelect.map((valor) => (
                    <option value={valor.id}>{valor.text}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Titulo"
                placeholder="Titulo"
                onChange={(e) => {
                  setPocket({ ...pocket, titulo: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Subtitulo"
                placeholder="Subtitulo"
                onChange={(e) => {
                  setPocket({ ...pocket, subtitulo: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Titulo no Google (TAG)"
                placeholder="Titulo no Google (TAG)"
                onChange={(e) => {
                  setPocket({ ...pocket, tituloGoogle: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Meta Descrição"
                placeholder="Meta Descrição"
                onChange={(e) => {
                  setPocket({ ...pocket, descricao: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="URL"
                placeholder="URL"
                onChange={(e) => {
                  setPocket({ ...pocket, url: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Imagem Horizontal</Label>
                <Dropzone onFileUploaded={setSelectedFileHorizontal} />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Imagem Vertical</Label>
                <Dropzone onFileUploaded={setSelectedFileVertical} />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Label>Segmentos:</Label>
              <Form.Field>
                {segmentos.map((segmento) => (
                  <Label>
                    <input
                      type="checkbox"
                      onClick={(e) =>
                        modifyCheckbox(e.target.checked, segmento.ordem)
                      }
                    />
                    {segmento.nome}
                  </Label>
                ))}
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Texto</Label>
                <TextEditor haveFullscreen text={text} />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Mais Vendido?</Label>
                <select
                  onChange={(e) =>
                    setPocket({ ...pocket, vendido: e.target.value })
                  }
                >
                  {optionBoolean.map((valor) => (
                    <option value={valor.id}>{valor.text}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Melhor Avaliado?</Label>
                <select
                  onChange={(e) =>
                    setPocket({ ...pocket, avaliado: e.target.value })
                  }
                >
                  {optionBoolean.map((valor) => (
                    <option value={valor.id}>{valor.text}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Recomendado?</Label>
                <select
                  onChange={(e) =>
                    setPocket({ ...pocket, recomendado: e.target.value })
                  }
                >
                  {optionBoolean.map((valor) => (
                    <option value={valor.id}>{valor.text}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  create();
                }}
              >
                Enviar
              </Form.Field>
              <Link to="/admin/blog/pocketbook4you/">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarPocket);
